/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/nb_NO';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Gå til HTML-editor"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Sjekk av universell utforming"
  },
  "action_to_take_b626a99a": {
    "message": "Handling å utføre:"
  },
  "add_8523c19b": {
    "message": "Legg til"
  },
  "add_a_caption_2a915239": {
    "message": "Legg til undertekst"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Legg til alternativ tekst til bildet"
  },
  "add_another_f4e50d57": {
    "message": "Legg til ei ny"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Legg til undertekstar"
  },
  "add_image_60b2de07": {
    "message": "Legg til bilde"
  },
  "add_one_9e34a6f8": {
    "message": "Legg til ein."
  },
  "additional_considerations_f3801683": {
    "message": "Ekstra omsyn"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Nabolenker med samme URL bør være ei lenke."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Justér"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Justering og lister"
  },
  "all_4321c3a1": {
    "message": "Alle"
  },
  "all_apps_a50dea49": {
    "message": "Alle appar"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetisk"
  },
  "alt_text_611fb322": {
    "message": "Alternativ tekst"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Koprodukt)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Det oppstod eit problem under lesing av fila"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Det oppstod ein feil ved nettverksførespurnaden "
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Det oppstod ein feil under opplasting av media"
  },
  "and_7fcc2911": {
    "message": "Og"
  },
  "angle_c5b4ec50": {
    "message": "Vinkel"
  },
  "announcement_fb4cb645": {
    "message": "Kunngjering"
  },
  "announcement_list_da155734": {
    "message": "Kunngjeringsliste"
  },
  "announcements_a4b8ed4a": {
    "message": "Kunngjeringar"
  },
  "apply_781a2546": {
    "message": "Bruk"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Bruk endringar på alle versjonar av dette ikondesignar-ikonet i emnet"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Nærmar seg grensa"
  },
  "approximately_e7965800": {
    "message": "Tilnærma"
  },
  "apps_54d24a47": {
    "message": "Appar"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Er du sikker på at du vil avbryte? Endringar blir kanskje ikkje lagra."
  },
  "arrows_464a3e54": {
    "message": "Piler"
  },
  "art_icon_8e1daad": {
    "message": "Kunstikon"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Storleiksforhold vil bli behalden"
  },
  "assignment_976578a8": {
    "message": "Oppgåve"
  },
  "assignments_1e02582c": {
    "message": "Oppgåver"
  },
  "asterisk_82255584": {
    "message": "Stjerne"
  },
  "attributes_963ba262": {
    "message": "Attributt"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Opptak av lyd og bilde støttast ikkje: bruk ein annan nettlesar."
  },
  "audio_options_feb58e2c": {
    "message": "Lydalternativ"
  },
  "audio_options_tray_33a90711": {
    "message": "Menyalternativ for lyd"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Audiospelar for { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Auto-lagra innhald finst. Vil du laste inn auto-lagra innhald i staden for?"
  },
  "available_folders_694d0436": {
    "message": "Tilgjengelege mapper"
  },
  "backslash_b2d5442d": {
    "message": "Bakstrek"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Standard"
  },
  "because_501841b": {
    "message": "Fordi"
  },
  "below_81d4dceb": {
    "message": "Nedanfor"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Stor sirkel"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomialkoeffisient"
  },
  "black_4cb01371": {
    "message": "Svart"
  },
  "blue_daf8fea9": {
    "message": "Blå"
  },
  "bottom_15a2a9be": {
    "message": "Nedst"
  },
  "bottom_third_5f5fec1d": {
    "message": "Nedre tredel"
  },
  "bowtie_5f9629e4": {
    "message": "Sløyfe"
  },
  "brick_f2656265": {
    "message": "Murstein"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Avbryt"
  },
  "cap_product_3a5265a6": {
    "message": "Cap-produkt"
  },
  "center_align_e68d9997": {
    "message": "Midtstill"
  },
  "centered_dot_64d5e378": {
    "message": "Sentrert prikk"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Midtstilt horisontale prikkar"
  },
  "change_alt_text_92654906": {
    "message": "Endre alternativ tekst"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Endre overskrifts-tag til avsnitt"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Endre kun denne overskrifta sitt nivå"
  },
  "change_text_color_1aecb912": {
    "message": "Endre tekstfarge"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Endringar blir kanskje ikkje lagra."
  },
  "characters_9d897d1c": {
    "message": "Teikn"
  },
  "characters_no_spaces_485e5367": {
    "message": "Teikn (Ingen mellomrom)"
  },
  "check_accessibility_3c78211c": {
    "message": "Sjekk tilgjengeligheit"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Leiter etter problem med tilgjengeligheit"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Vel undertekstfil"
  },
  "choose_usage_rights_33683854": {
    "message": "Vel bruksrett..."
  },
  "circle_484abe63": {
    "message": "Sirkel"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "sirkulær uordna liste"
  },
  "clear_2084585f": {
    "message": "Fjern"
  },
  "clear_image_3213fe62": {
    "message": "Tøm bilde"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klikk eller shift+klikk for å gå til html-editoren."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klikk for å sette inn { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klikk for å skjule førehandsvising"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klikk for å setje inn ei lenke i editoren. "
  },
  "click_to_show_preview_faa27051": {
    "message": "Klikk for å vise førehandsvising"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Om du lukkar menyen eller dialogen, kjem du tilbake til redigeringsområdet"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Lukk sjekk av universell utforming"
  },
  "close_d634289d": {
    "message": "Lukk"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Tekst-fil må vere mindre enn { maxKb } kB."
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Undertekstar"
  },
  "clubs_suit_c1ffedff": {
    "message": "Kløver (Korttype)"
  },
  "collaborations_5c56c15f": {
    "message": "Samarbeid"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Skjul og lukk { types }"
  },
  "color_a363e1b0": {
    "message": "Farge"
  },
  "color_picker_6b359edf": {
    "message": "Fargeveljar"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Fargeveljar ({ colorName } vald)"
  },
  "column_e1ae5c64": {
    "message": "kollonne"
  },
  "column_group_1c062368": {
    "message": "kollonnegruppe"
  },
  "complex_numbers_a543d004": {
    "message": "Komplekse tal"
  },
  "compose_44c904f4": {
    "message": "Komponere"
  },
  "computer_1d7dfa6f": {
    "message": "Datamaskin"
  },
  "congruent_5a244acd": {
    "message": "Kongruent"
  },
  "contains_311f37b7": {
    "message": "Inneheld"
  },
  "content_1440204b": {
    "message": "Innhald"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Innhald i editoren vil bli endra. Vel avbryt for å behalde det opprinnelege innhaldet"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Innhald lastar framleis og vil ikkje bli integrert godt nok dersom du held fram."
  },
  "content_subtype_5ce35e88": {
    "message": "Innhald underkategori"
  },
  "content_type_2cf90d95": {
    "message": "Innhaldstype"
  },
  "coproduct_e7838082": {
    "message": "Koprodukt"
  },
  "copy_9748f9f": {
    "message": "Kopi"
  },
  "copyright_holder_66ee111": {
    "message": "Rettshavar:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Kunne ikkje sette inn innhald: \"{ itemType }\" er for augneblinken ikkje støtta i Canvas"
  },
  "count_40eced3b": {
    "message": "Antal"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 words}\n    one {1 word}\n  other {# words}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# element lasta}\n  other {# element lasta}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Emnedokument"
  },
  "course_files_62deb8f8": {
    "message": "Emnefiler"
  },
  "course_files_a31f97fc": {
    "message": "Emnefiler"
  },
  "course_images_f8511d04": {
    "message": "Hent bilde frå emnefiler"
  },
  "course_link_b369426": {
    "message": "Emnelenke"
  },
  "course_links_b56959b9": {
    "message": "Emnelenker"
  },
  "course_media_ec759ad": {
    "message": "Emnemedier"
  },
  "course_navigation_dd035109": {
    "message": "Emnenavigering"
  },
  "create_icon_110d6463": {
    "message": "Lag ikon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Lag ikondesignar-ikon"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons-lisens:"
  },
  "crop_image_41bf940c": {
    "message": "Skjær bilde"
  },
  "crop_image_807ebb08": {
    "message": "Skjær bilde"
  },
  "cup_product_14174434": {
    "message": "Cup-produkt"
  },
  "current_image_f16c249c": {
    "message": "Gjeldande bilde"
  },
  "current_link_945a47ee": {
    "message": "Gjeldande lenke"
  },
  "current_volume_level_c55ab825": {
    "message": "Gjeldande volumnivå"
  },
  "custom_6979cd81": {
    "message": "Eigendefinert"
  },
  "custom_width_and_height_pixels_946eea7c": {
    "message": "Eigendefinert bredde og høgde (pikslar)"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Dolk"
  },
  "date_added_ed5ad465": {
    "message": "Dato lagd til"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Dekortativt ikon"
  },
  "decorative_image_fde98579": {
    "message": "Dekorativt bilde"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorativt { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Reduser innrykk"
  },
  "deep_purple_bb3e2907": {
    "message": "Mørk lilla"
  },
  "default_9db103d": {
    "message": "Standard"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "standard uordna liste med kulepunkt"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "standard numerisk ordna liste"
  },
  "definite_integral_fe7ffed1": {
    "message": "Bestemt integral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Grader-symbol"
  },
  "delimiters_4db4840d": {
    "message": "Skiljeteikn"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Beskriv ikonet)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Beskriv { TYPE })"
  },
  "describe_the_video_2fe8f46a": {
    "message": "(Skildre videoen)"
  },
  "description_436c48d7": {
    "message": "Skildring"
  },
  "details_98a31b68": {
    "message": "Detaljar"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonale prikkar"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamant"
  },
  "diamonds_suit_526abaaf": {
    "message": "Ruter (Korttype)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Dimensjonstype"
  },
  "dimensions_45ddb7b7": {
    "message": "Dimensjonar"
  },
  "directionality_26ae9e08": {
    "message": "Retningsgivande"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Rediger LaTeX direkte"
  },
  "disable_preview_222bdf72": {
    "message": "Deaktiver førehandsvising"
  },
  "discussion_6719c51d": {
    "message": "Diskusjon"
  },
  "discussions_a5f96392": {
    "message": "Diskusjonar"
  },
  "discussions_index_6c36ced": {
    "message": "Diskusjonsoversikt"
  },
  "disjoint_union_e74351a8": {
    "message": "Disjunkt union"
  },
  "display_options_315aba85": {
    "message": "Vis alternativ"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Vis lenketekst (opnast i ny fane)"
  },
  "division_sign_72190870": {
    "message": "Divisjonssymbol"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokument"
  },
  "done_54e3d4b6": {
    "message": "Fullført"
  },
  "double_dagger_faf78681": {
    "message": "Dobbeldolk"
  },
  "down_5831a426": {
    "message": "Ned"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Diagonal pil ned til venstre"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Diagonal pil ned til høyre"
  },
  "download_filename_2baae924": {
    "message": "Last ned { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Pil nedover"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Nedoverpeikande triangel"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Dra ei fil hit"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Dra og slipp, eller klikk for å hente fil frå disk"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Dragrep. Bruk piltastane opp og ned for å endre storleik"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Frist: Fleire datoar"
  },
  "due_when_7eed10c6": {
    "message": "Frist: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Rediger alternativ tekst for dette ikonet"
  },
  "edit_c5fbea07": {
    "message": "Rediger"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Rediger emnelenke"
  },
  "edit_equation_f5279959": {
    "message": "Rediger likning"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Rediger eksisterande ikondesignar-ikon"
  },
  "edit_icon_2c6b0e91": {
    "message": "Rediger ikon"
  },
  "edit_link_7f53bebb": {
    "message": "Endre lenke"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element som startar med { start }"
  },
  "embed_828fac4a": {
    "message": "Sett inn"
  },
  "embed_code_314f1bd5": {
    "message": "Integrer kode"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Set inn innhald frå eksternt verktøy"
  },
  "embed_image_1080badc": {
    "message": "Sett inn bilde"
  },
  "embed_video_a97a64af": {
    "message": "Integrer video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "innebygd innhald"
  },
  "empty_set_91a92df4": {
    "message": "Tomt sett"
  },
  "encircled_dot_8f5e51c": {
    "message": "Omsirkla prikk"
  },
  "encircled_minus_72745096": {
    "message": "Omsirkla minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Omsirkla pluss"
  },
  "encircled_times_5700096d": {
    "message": "Omsirkla multiplikasjon"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ingeniør-ikon"
  },
  "english_icon_25bfe845": {
    "message": "Engelsk ikon"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Oppgi minst 3 teikn for å søke"
  },
  "enter_replacement_text_17631bbc": {
    "message": "sett inn ny tekst"
  },
  "enter_search_text_26cb4459": {
    "message": "oppgi søketekst"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Variant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Likskapsteikn"
  },
  "equation_1c5ac93c": {
    "message": "Likning"
  },
  "equation_editor_39fbc3f1": {
    "message": "Likningseditor"
  },
  "equilibrium_6ff3040b": {
    "message": "Likevekt"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Ekvivalensklasse"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ekvivalent (Identitet)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Eksisterer"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Avslutt fullskjerm"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Utvid førehandsvisinga som standard"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Vis og sjå { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Ekstern lenke"
  },
  "external_tool_frame_70b32473": {
    "message": "Ekstern verktøyramme"
  },
  "external_tools_6e77821": {
    "message": "Eksterne verktøy"
  },
  "extra_large_b6cdf1ff": {
    "message": "Ekstra stor"
  },
  "extra_small_9ae33252": {
    "message": "Svært liten"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Utanomfaglig ikon"
  },
  "f_function_fe422d65": {
    "message": "F (Funksjon)"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Henting av filinnhald mislukkast"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Kunne ikkje hente innhald frå eksternt verktøy"
  },
  "file_name_8fd421ff": {
    "message": "Filnamn"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Lagringskvota er overskriden"
  },
  "file_url_c12b64be": {
    "message": "Fil-URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } filikon"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } førehandsvising av bilde"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } førehandsvising av tekst"
  },
  "files_c300e900": {
    "message": "Filer"
  },
  "files_index_af7c662b": {
    "message": "Filoversikt"
  },
  "find_8d605019": {
    "message": "Finn"
  },
  "find_and_replace_6e345933": {
    "message": "Finn og erstatt"
  },
  "finish_bc343002": {
    "message": "Fullfør"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Fiks overskriftshierarkiet"
  },
  "flat_music_76d5a5c3": {
    "message": "Under (Musikk)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Sentrer alternativ-menyen"
  },
  "folder_tree_fbab0726": {
    "message": "Mappestruktur"
  },
  "for_all_b919f972": {
    "message": "For alle"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Formater som ei liste"
  },
  "formatting_5b143aa8": {
    "message": "Formatering"
  },
  "forward_slash_3f90f35e": {
    "message": "Skråstrek"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Fann auto-lagra innhald"
  },
  "fraction_41bac7af": {
    "message": "Brøk"
  },
  "fullscreen_873bf53f": {
    "message": "Full skjerm"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Genererer førehandsvising..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "GIF/PNG bildeformat større enn { size } KB er ikkje støtta."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Gå til menylinja i redigeringsprogrammet"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Gå til verktøylinja i redigeringsprogrammet"
  },
  "grades_a61eba0a": {
    "message": "Vurderingar"
  },
  "greater_than_e98af662": {
    "message": "Større enn"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Større enn eller lik"
  },
  "greek_65c5b3f7": {
    "message": "Gresk"
  },
  "green_15af4778": {
    "message": "Grønt"
  },
  "grey_a55dceff": {
    "message": "Grå"
  },
  "group_documents_8bfd6ae6": {
    "message": "Grupper dokument"
  },
  "group_files_4324f3df": {
    "message": "Gruppefiler"
  },
  "group_files_82e5dcdb": {
    "message": "Gruppefiler"
  },
  "group_images_98e0ac17": {
    "message": "Grupper bilde"
  },
  "group_isomorphism_45b1458c": {
    "message": "Gruppeisomorfi"
  },
  "group_link_63e626b3": {
    "message": "Gruppelenke"
  },
  "group_links_9493129e": {
    "message": "Grupper lenker"
  },
  "group_media_2f3d128a": {
    "message": "Grupper media"
  },
  "group_navigation_99f191a": {
    "message": "Gruppenavigering"
  },
  "h_bar_bb94deae": {
    "message": "H Bar"
  },
  "hat_ea321e35": {
    "message": "Hatt"
  },
  "header_column_f27433cb": {
    "message": "Overskriftskollonne"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Overskriftsrad- og kollonne"
  },
  "header_row_f33eb169": {
    "message": "Overskriftsrad"
  },
  "heading_2_5b84eed2": {
    "message": "Overskrift 2"
  },
  "heading_3_2c83de44": {
    "message": "Overskrift 3"
  },
  "heading_4_b2e74be7": {
    "message": "Overskrift 4"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Overskriftsnivå burde ikkje hoppast over"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Overskift som startar med { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Overskrifter bør ikkje innehalde meir enn 120 karakterer."
  },
  "health_icon_8d292eb5": {
    "message": "Helseikon"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hjarter (Kortfage)"
  },
  "height_69b03e15": {
    "message": "Høgde"
  },
  "hexagon_d8468e0d": {
    "message": "Sekskant"
  },
  "hide_description_bfb5502e": {
    "message": "Skjul skildring"
  },
  "hide_title_description_caf092ef": {
    "message": "Skjul { title } skildring"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Marker eit element for å aktivere verktøylinja."
  },
  "home_351838cd": {
    "message": "Heim"
  },
  "html_code_editor_fd967a44": {
    "message": "HTML-editor"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-editor"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Eg har løyve til å bruke denne fila. "
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Eg er rettshavar"
  },
  "icon_215a1dc6": {
    "message": "Ikon"
  },
  "icon_8168b2f8": {
    "message": "Ikon"
  },
  "icon_color_b86dd6d6": {
    "message": "Ikonfarge"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikondesignar-ikon"
  },
  "icon_options_7e32746e": {
    "message": "Alternativ for ikon"
  },
  "icon_options_tray_2b407977": {
    "message": "Menyalternativ for ikon"
  },
  "icon_preview_1782a1d9": {
    "message": "Ikon-førehandsvisning"
  },
  "icon_shape_30b61e7": {
    "message": "Ikonform"
  },
  "icon_size_9353edea": {
    "message": "Ikonstorleik"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Om du ikkje vel bruksrettar no, vil ikkje fila bli publisert etter at ho er lasta opp. "
  },
  "image_8ad06": {
    "message": "Bilde"
  },
  "image_c1c98202": {
    "message": "bilde"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Filnamn til bilder bør ikke brukast som alternativ tekst for å beskrive bildeinnhaldet."
  },
  "image_options_5412d02c": {
    "message": "Alternativ for bilde"
  },
  "image_options_tray_90a46006": {
    "message": "Redigeringsmeny for bilde"
  },
  "image_to_crop_3a34487d": {
    "message": "Bilde å skjere"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Bilde med filnamn { file }"
  },
  "images_7ce26570": {
    "message": "Bilde"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Bilder bør innehlade ein alt-attributt som beskriv bildeinnhaldet."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Imaginær del (av komplekst tal)"
  },
  "in_element_of_19ca2f33": {
    "message": "I (Element av)"
  },
  "increase_indent_6af90f7c": {
    "message": "Auk innrykk"
  },
  "indefinite_integral_6623307e": {
    "message": "Ubestemt integral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } av { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Inferens"
  },
  "infinity_7a10f206": {
    "message": "Uendeleg"
  },
  "insert_593145ef": {
    "message": "Set inn"
  },
  "insert_link_6dc23cae": {
    "message": "Sett inn lenke"
  },
  "insert_math_equation_57c6e767": {
    "message": "Sett inn matematikklikning"
  },
  "integers_336344e1": {
    "message": "Heiltal"
  },
  "intersection_cd4590e4": {
    "message": "Snitt"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ugyldig oppføring"
  },
  "invalid_file_c11ba11": {
    "message": "Ugyldig fil"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Ugyldig filtype"
  },
  "invalid_url_cbde79f": {
    "message": "Ugyldig URL"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problem { num }/{ total }"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Variant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Hurtigtastar"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Tastatur navigerer til lenker med bruk av Tab-tasten. To lenker ved siden av kvarandre som viser til same destinasjon kan vere forvirrande for tastaturbrukarar."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Språkvitskap-ikon"
  },
  "languages_icon_9d20539": {
    "message": "Språk-ikon"
  },
  "large_9c5e80e7": {
    "message": "Stort"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Lær meir om lenker ved siden av kvarande"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Lær meir om fargekontrast"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Lær meir om organisering av sideoverskrifter"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Lær meir om riktig organisering av sideoverskrifter"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Lær meir om tabelloverskrifter"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Lær meir om bruk av alternativ tekst til bilder"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Lær meir om bruk av tabelltitlar"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Lær meir om bruk av filnamn som alternativ tekst"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Lær meir om bruk av lister"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Lær meir om bruk av scope attributtar med tabellar"
  },
  "leave_as_is_4facfe55": {
    "message": "Forlat som det er"
  },
  "left_3ea9d375": {
    "message": "Venstre"
  },
  "left_align_43d95491": {
    "message": "Venstrejuster"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Venstre vinkelparentes"
  },
  "left_arrow_4fde1a64": {
    "message": "Pil venstre"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Pil venstre med krok"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Venstre tak"
  },
  "left_curly_brace_1726fb4": {
    "message": "Venstre krøllparentes"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Harpunpil ned mot venstre"
  },
  "left_floor_29ac2274": {
    "message": "Venstre gulv"
  },
  "left_to_right_e9b4fd06": {
    "message": "Venste mot høgre"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Harpunpil opp mot venstre"
  },
  "leftward_arrow_1e4765de": {
    "message": "Pil venstre"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Venstrepeikande triangel"
  },
  "less_than_a26c0641": {
    "message": "Mindre enn"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Mindre enn eller lik"
  },
  "library_icon_ae1e54cf": {
    "message": "Bibliotek-ikon"
  },
  "light_blue_5374f600": {
    "message": "Lyseblå"
  },
  "link_7262adec": {
    "message": "Lenke"
  },
  "link_options_a16b758b": {
    "message": "Lenkealternativ"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "Lenketype:  { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Lenke med tekst som startar med { start }"
  },
  "links_14b70841": {
    "message": "Lenker"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Lenker til eit ekstern område."
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Lister burde formaterast som lister."
  },
  "load_more_35d33c7": {
    "message": "Last fleire"
  },
  "loading_25990131": {
    "message": "Lastar..."
  },
  "loading_bde52856": {
    "message": "Lastar"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Mislukka å laste undertekster"
  },
  "loading_external_tool_d839042c": {
    "message": "Lastar eksternt verktøy"
  },
  "loading_failed_b3524381": {
    "message": "Opplasting mislukkast..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Opplasting mislukkast."
  },
  "loading_folders_d8b5869e": {
    "message": "Lastar mapper"
  },
  "loading_please_wait_d276220a": {
    "message": "Lastar, vent"
  },
  "loading_preview_9f077aa1": {
    "message": "Lastar førehandsvisning"
  },
  "locked_762f138b": {
    "message": "Låst"
  },
  "logical_equivalence_76fca396": {
    "message": "Logisk ekvivalens"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logisk ekvivalens (Kort)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logisk ekvivalens (Kort og tjukk)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logisk ekvivalens (Tjukk)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Låge horisontale prikkar"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Avbild til"
  },
  "math_icon_ad4e9d03": {
    "message": "Matematikk-ikon"
  },
  "media_af190855": {
    "message": "Media"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Mediefil vart prosessert. Prøv på ny seinare."
  },
  "media_title_2112243b": {
    "message": "Mediatittel"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "merge_links_2478df96": {
    "message": "Slå saman lenker"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon deaktivert"
  },
  "middle_27dc1d5": {
    "message": "Midtpunkt"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimer førehandsvising av fil"
  },
  "minimize_video_20aa554b": {
    "message": "Minimer video"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/Pluss"
  },
  "misc_3b692ea7": {
    "message": "Diverse"
  },
  "miscellaneous_e9818229": {
    "message": "Diverse"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Modular"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Flytter bildet til utskjering { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Fleirfargebilde"
  },
  "multiplication_sign_15f95c22": {
    "message": "Multiplikasjonsteikn"
  },
  "music_icon_4db5c972": {
    "message": "Musikk-ikon"
  },
  "my_files_2f621040": {
    "message": "Mine filer"
  },
  "n_th_root_9991a6e4": {
    "message": "N-te rot"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Namn"
  },
  "natural_music_54a70258": {
    "message": "Naturleg (Musikk)"
  },
  "natural_numbers_3da07060": {
    "message": "Naturlege tal"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Naviger gjennom menyen eller verktøylinja"
  },
  "navigation_ee9af92d": {
    "message": "Navigasjon"
  },
  "nested_greater_than_d852e60d": {
    "message": "Nøsta større enn"
  },
  "nested_less_than_27d17e58": {
    "message": "Nøsta mindre enn"
  },
  "new_quiz_34aacba6": {
    "message": "Ny quiz"
  },
  "next_40e12421": {
    "message": "Neste"
  },
  "next_findtext_9d69f0fe": {
    "message": "Neste { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Ingen problem med tilgjengeligheit funne"
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Ingen kunngjeringer oppretta endå"
  },
  "no_announcements_found_20185afc": {
    "message": "Ingen kunngjeringer funne"
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Ingen oppgåver oppretta endå"
  },
  "no_assignments_found_79e46d7f": {
    "message": "Ingen oppgåver funne"
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Ingen endringar å lagre."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Ingen diskusjonar oppretta endå"
  },
  "no_discussions_found_9284063b": {
    "message": "Ingen diskusjonar funne"
  },
  "no_e16d9132": {
    "message": "Nei"
  },
  "no_file_chosen_9a880793": {
    "message": "Ingen filer er valde"
  },
  "no_headers_9bc7dc7f": {
    "message": "Ingen overskrifter"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Ingen modular oppretta endå"
  },
  "no_modules_found_2df43a40": {
    "message": "Ingen moduler funne"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Ingen sider er oppretta."
  },
  "no_pages_found_6799350": {
    "message": "Ingen sider funne"
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Førehandsvising er ikkje tilgjengeleg for denne fila."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Ingen quizar oppretta endå"
  },
  "no_quizzes_found_c80c537a": {
    "message": "Ingen quizar funne"
  },
  "no_results_940393cf": {
    "message": "Utan resultat. "
  },
  "no_results_found_58717065": {
    "message": "Finn ikkje resultat"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Ingen resultat funne for { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ingen video"
  },
  "none_3b5e34d2": {
    "message": "Ingen"
  },
  "none_selected_b93d56d2": {
    "message": "Ingen vald"
  },
  "not_equal_6e2980e6": {
    "message": "Ikkje lik"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Ikkje i (Ikkje eit element av)"
  },
  "not_negation_1418ebb8": {
    "message": "Ikkje (Negasjon)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ikkje delmengd"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ikkje delmengd (Streng)"
  },
  "not_superset_5556b913": {
    "message": "Ikkje supersett"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ikkje supersett (Streng)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Åttekant"
  },
  "olive_6a3e4d6b": {
    "message": "Oliven"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Ein av dei følgande stilane må leggast til for å lagre ikonet: farge, storleik, tekst, eller bilde"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Ein eller fleire filer kunne ikkje limast inn. Prøv å laste opp eller dra og slipp filer."
  },
  "open_circle_e9bd069": {
    "message": "Open sirkel"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Opne denne hurtigtastar-dialogen"
  },
  "open_title_application_fd624fc5": {
    "message": "Opne { title } applikasjon"
  },
  "operators_a2ef9a93": {
    "message": "Operatør"
  },
  "options_3ab0ea65": {
    "message": "Alternativ"
  },
  "or_9b70ccaa": {
    "message": "Eller"
  },
  "orange_81386a62": {
    "message": "Oransje"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Ordna og uordna lister"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Andre hurtigtastar for redigering kan ein finne i"
  },
  "outline_color_3ef2cea7": {
    "message": "Farge på omriss"
  },
  "outline_size_a6059a21": {
    "message": "Storleik på omriss"
  },
  "page_50c4823d": {
    "message": "Side"
  },
  "pages_e5414c2c": {
    "message": "Sider"
  },
  "paragraph_5e5ad8eb": {
    "message": "Avsnitt"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Avsnitt startar med { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallell"
  },
  "partial_derivative_4a9159df": {
    "message": "Partiell (Derivert)"
  },
  "paste_5963d1c1": {
    "message": "Lim inn"
  },
  "pause_12af3bb4": {
    "message": "Pause"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagon"
  },
  "people_b4ebb13c": {
    "message": "Personar"
  },
  "percentage_34ab7c2c": {
    "message": "Prosenttal"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Prosent må være eit tal"
  },
  "performing_arts_icon_f3497486": {
    "message": "Utøvande kunst-ikon"
  },
  "perpendicular_7c48ede4": {
    "message": "Vinkelrett"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Variant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Kroppsøving-ikon"
  },
  "pi_dc4f0bd8": {
    "message": "P"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Variant)"
  },
  "pink_68ad45cb": {
    "message": "Rosa"
  },
  "pixels_52ece7d1": {
    "message": "Pixlar"
  },
  "play_1a47eaa7": {
    "message": "Spel av"
  },
  "play_media_comment_35257210": {
    "message": "Spel av medieinnhald."
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Vær god å gje Canvas tilgang til din mikrofon og ditt webkamera"
  },
  "plus_d43cd4ec": {
    "message": "Pluss"
  },
  "plus_minus_f8be2e83": {
    "message": "Pluss/Minus"
  },
  "posted_when_a578f5ab": {
    "message": "Posta: { when }"
  },
  "power_set_4f26f316": {
    "message": "Potensmengd"
  },
  "precedes_196b9aef": {
    "message": "Føregåande"
  },
  "precedes_equal_20701e84": {
    "message": "Føregåande lik"
  },
  "preformatted_d0670862": {
    "message": "Førehandsformatert"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Førre"
  },
  "preview_53003fd2": {
    "message": "Førehandsvising"
  },
  "preview_a3f8f854": {
    "message": "Førehandsvisning"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Førehandsvisning i nytt lag"
  },
  "preview_inline_9787330": {
    "message": "Førehandsvising i teksten"
  },
  "previous_bd2ac015": {
    "message": "Førre"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Førre { findText }"
  },
  "prime_917ea60e": {
    "message": "Primtal"
  },
  "prime_numbers_13464f61": {
    "message": "Primtal"
  },
  "product_39cf144f": {
    "message": "Produkt"
  },
  "proportional_f02800cc": {
    "message": "Proporsjonal"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokoll må vere anten ftp, http, https, mailto, skype, tel, eller utelatast"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "publisert"
  },
  "published_when_302d8e23": {
    "message": "Publisert: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Gresskar"
  },
  "purple_7678a9fc": {
    "message": "Lilla"
  },
  "quaternions_877024e0": {
    "message": "Kvaternion"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Quizar"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rasjonelle tal"
  },
  "real_numbers_7c99df94": {
    "message": "Reelle tal"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Reell del (av komplekst tal)"
  },
  "record_7c9448b": {
    "message": "Spel inn"
  },
  "record_upload_media_5fdce166": {
    "message": "Ta opp / last opp media"
  },
  "recording_98da6bda": {
    "message": "Opptak"
  },
  "red_8258edf3": {
    "message": "Raud"
  },
  "relationships_6602af70": {
    "message": "Relasjon"
  },
  "religion_icon_246e0be1": {
    "message": "Religion-ikon"
  },
  "remove_f47dc62a": {
    "message": "Fjern"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Fjern stil på overskrift"
  },
  "remove_link_d1f2f4d0": {
    "message": "Fjern lenke"
  },
  "replace_all_d3d68b3": {
    "message": "Erstatt alt"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Erstatt alt { findText } med { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Erstatt"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Erstatt { findText } med { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Erstatt med"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Erstatta { alertFindText } med { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Erstatta alt { alertFindText } med { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Tilbakestill"
  },
  "resize_ec83d538": {
    "message": "Endre storleik"
  },
  "restore_auto_save_deccd84b": {
    "message": "Gjenopprette auto-lagring?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultat { index } av { max }."
  },
  "retry_ebd5f8ba": {
    "message": "Prøv på nytt"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Variant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Redigeringsprogram for rikt innhald"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Rikt tekstområde. Trykk { OSKey }+F8 for hurtigtastar i teksteditoren."
  },
  "right_71ffdc4d": {
    "message": "Høgre"
  },
  "right_align_39e7a32a": {
    "message": "Høgrejuster"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Høgre vinkelparentes"
  },
  "right_arrow_35e0eddf": {
    "message": "Pil høgre"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Pil høgre med krok"
  },
  "right_ceiling_839dc744": {
    "message": "Høgre tak"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Høgre krøllparentes"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Harpunpil ned mot høgre"
  },
  "right_floor_5392d5cf": {
    "message": "Høgre golv"
  },
  "right_to_left_9cfb092a": {
    "message": "Høgre mot venstre"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Harpunpil opp mot høgre"
  },
  "rightward_arrow_32932107": {
    "message": "Pil høgre"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Høgrepeikande triangel"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Roter bilde -90 grader"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Roter bilde 90 grader"
  },
  "rotation_9699c538": {
    "message": "Rotasjon"
  },
  "row_fc0944a7": {
    "message": "Rad"
  },
  "row_group_979f5528": {
    "message": "Radgruppe"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "I den pene HTML-editoren kan du ikkje redigere med tastatur. Gå til ein rein HTML-editor her."
  },
  "save_11a80ec3": {
    "message": "Lagre"
  },
  "save_copy_ca63944e": {
    "message": "Lagre kopi"
  },
  "save_media_cb9e786e": {
    "message": "Lagre media"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Lagra ikondesignar-ikon"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Skjermlesarar kan ikkje vite kva som visast i eit bilde utan alternativ tekst, og filnamn beskriv ofte ikkje konteksten eller betydninga."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Skjermlesarar kan ikkje vite kva som visast i eit bilde utan ein alternativ tekst, som skildrar innhaldet og tydinga av bildet. Alternative tekstar bør være enkle og konkrete."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Skjermlesarar kan ikkje vite kva som visast i eit bilde utan ein alternativ tekst, som skildrar innhaldet og tydinga av bildet."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Skjermlesarar kan ikkje tolke tabellar utan riktig tabellstruktur. Tabellskildringar skildrar konteksten og korleis ein skal tyda tabellen."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Skjermlesarar kan ikkje tolke tabellar utan riktig struktur. Tabelloverskrifter gir retning og oversikt over innhaldet."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Søk"
  },
  "select_audio_source_21043cd5": {
    "message": "Vel lydkilde"
  },
  "select_crop_shape_d441feeb": {
    "message": "Vel skjæringsform"
  },
  "select_language_7c93a900": {
    "message": "Vel språk"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Vel videokilde"
  },
  "selected_274ce24f": {
    "message": "Valt"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Vald { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Utval"
  },
  "set_minus_b46e9b88": {
    "message": "Sett minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Legg inn tabelloverskrift"
  },
  "sharp_music_ab956814": {
    "message": "Over (Musikk)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Piltastar"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Bruk Shift-O for å opne den pene HTML-editoren."
  },
  "shortcut_911d6255": {
    "message": "Snarveg"
  },
  "show_all_967a90f0": {
    "message": "Vis alt"
  },
  "show_audio_options_b489926b": {
    "message": "Vis lydalternativ"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Vis alternativ for bilde"
  },
  "show_link_options_545338fd": {
    "message": "Vis lenkealternativ"
  },
  "show_studio_media_options_a0c748c6": {
    "message": "Vis medievalg for studio"
  },
  "show_video_options_6ed3721a": {
    "message": "Vis videoalternativ"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Personer med normalt syn navigerer nettsider raskt ved å sjå etter store eller utheva titlar. Skjermlesarar brukar titlar for å forstå konteksten. Titlar burde bruke riktig struktur."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Variant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Monokromt bilde"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Monokrom bildefarge"
  },
  "size_b30e1077": {
    "message": "Storleik"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Storleiken på tekst-fila er større enn grensa på { max } kB."
  },
  "small_b070434a": {
    "message": "Liten"
  },
  "solid_circle_9f061dfc": {
    "message": "Solid sirkel"
  },
  "something_went_wrong_89195131": {
    "message": "Noko gjekk gale."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Noko gjekk gale med tilgangen til kamera ditt."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Noko gjekk gale. Veit ikkje kva som kan visast."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Noko gjekk gale. Sjekk internettforbindelsen, last sida på ny, og prøv på nytt."
  },
  "something_went_wrong_d238c551": {
    "message": "Noko gjekk gale"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Noko gjekk gale under deling av skjermen din."
  },
  "sort_by_e75f9e3e": {
    "message": "Sorter etter"
  },
  "spades_suit_b37020c2": {
    "message": "Spar (Korttype)"
  },
  "square_511eb3b3": {
    "message": "Kvadrat"
  },
  "square_cap_9ec88646": {
    "message": "Kvadratisk cap"
  },
  "square_cup_b0665113": {
    "message": "Kvadratisk cup"
  },
  "square_root_e8bcbc60": {
    "message": "Kvadratrot"
  },
  "square_root_symbol_d0898a53": {
    "message": "Kvadratrotsymbol"
  },
  "square_subset_17be67cb": {
    "message": "Kvadratisk delmengd"
  },
  "square_subset_strict_7044e84f": {
    "message": "Kvadratisk delmengd (Streng)"
  },
  "square_superset_3be8dae1": {
    "message": "Kvadratisk supersett"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Kvadratisk Supersett (Streng)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "firkanta uordna liste"
  },
  "star_8d156e09": {
    "message": "Merk med stjerne"
  },
  "start_over_f7552aa9": {
    "message": "Start på nytt"
  },
  "start_recording_9a65141a": {
    "message": "Start opptak"
  },
  "steel_blue_14296f08": {
    "message": "Stålblå"
  },
  "studio_media_options_ee504361": {
    "message": "Medieval for studio"
  },
  "styles_2aa721ef": {
    "message": "Stilar"
  },
  "submit_a3cc6859": {
    "message": "Send!"
  },
  "submitting_b90fac62": {
    "message": "Leverer..."
  },
  "subscript_59744f96": {
    "message": "Senka skrift"
  },
  "subset_19c1a92f": {
    "message": "Delmengd"
  },
  "subset_strict_8d8948d6": {
    "message": "Delmengd (Streng)"
  },
  "succeeds_9cc31be9": {
    "message": "Etterfølgjer"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Etterfølgjer lik"
  },
  "sum_b0842d31": {
    "message": "Sum"
  },
  "superscript_8cb349a2": {
    "message": "Heva skrift"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Hevet skrift og senket skrift"
  },
  "superset_c4db8a7a": {
    "message": "Supersett"
  },
  "superset_strict_c77dd6d2": {
    "message": "Supersett (Streng)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Støtta filtypar: SRT og WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Byt til pen HTML-editor"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Byt til rå HTML-editor"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Byt til HTML-editor"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Byt til rikteksteditoren"
  },
  "syllabus_f191f65b": {
    "message": "Emneoversikt"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Systemlyd tillaten"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Systemlyd deaktivert"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/piltastar"
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Blågrøn"
  },
  "text_7f4593da": {
    "message": "Tekst"
  },
  "text_background_color_16e61c3f": {
    "message": "Bakgrunnsfarge for tekst"
  },
  "text_color_acf75eb6": {
    "message": "Tekstfarge"
  },
  "text_optional_384f94f7": {
    "message": "Tekst (valfri)"
  },
  "text_position_8df8c162": {
    "message": "Tekstplassering"
  },
  "text_size_887c2f6": {
    "message": "Tekststorleik"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Førehandsvisinga av dokumentet blir behandla no. Prøv på nytt seinare."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materialet er ikkje opphavsrettbeskytta"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materialet er lisensiert under Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Materialet er brukt i samsvar med sitatretten"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "I den pene HTML-editoren kan du ikkje redigere med tastatur. Trykk Shift-O for å opne den reine HTML-editoren."
  },
  "therefore_d860e024": {
    "message": "Derfor"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Variant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Tjukk pil nedover"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Tjukk pil venstre"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Tjukk pil venstre"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Tjukk pil høgre"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Tjukk pil høgre"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Tjukk pil oppover"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dette dokumentet kan ikkje visast i Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Kan ikkje gje att som grunnleggande vising."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Dette bildet er for tida utilgjengeleg"
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Sjølv om videoen din har rett tittel i nettlesaren, er den ikkje oppdatert i databasen."
  },
  "title_ee03d132": {
    "message": "Tittel"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Vert posta: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Gjeremål: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Veksle { summary } gruppe"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Vis/skjul tips"
  },
  "tools_2fcf772e": {
    "message": "Verktøy"
  },
  "top_66e0adb6": {
    "message": "Topp"
  },
  "tray_839df38a": {
    "message": "Sidemeny"
  },
  "triangle_6072304e": {
    "message": "Trekant"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "vel ctrl+F9 for å sjå alternativ for bildet. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "vel ctrl+F9 for å sjå alternativ for lenke. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "vel ctrl+F9 for å sjå alternativ for tabell. { text }"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "upublisert"
  },
  "untitled_16aa4f2b": {
    "message": "Utan tittel"
  },
  "untitled_efdc2d7d": {
    "message": "utan tittel"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Diagonal pil opp til venstre"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Diagonal pil opp til høgre"
  },
  "up_c553575d": {
    "message": "Opp"
  },
  "updated_link_a827e441": {
    "message": "Oppdatert lenke"
  },
  "upload_document_253f0478": {
    "message": "Last opp dokument frå disk"
  },
  "upload_file_fd2361b8": {
    "message": "Last opp fil"
  },
  "upload_image_6120b609": {
    "message": "Last opp bilde frå disk"
  },
  "upload_media_ce31135a": {
    "message": "Last opp media"
  },
  "upload_record_media_e4207d72": {
    "message": "Last opp/Ta opp media"
  },
  "uploading_19e8a4e7": {
    "message": "Lastar opp"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "alfabetisk ordna liste i store bokstavar"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Stor Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Stor Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Stor Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Stor Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Stor Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Stor Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Stor Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "numerisk ordna liste med romertal"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Stor Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Stor Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Stor Upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Stor Xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Oppover- og nediverpeikande pil"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Oppover- og nedoverpeikande pil (Tjukk)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Pil opp"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Oppoverpeikande triangel"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Bruksrett:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Bruksrettar (obligatorisk)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Bruk piltastane for å navigere mellom alternativa."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Bruk piltastane for å velje ein figur."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Bruk piltastane for å velje ein storleik."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Bruk piltastane for å velje plassering for teksten"
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Bruk piltastane for å velje tekststorleik"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Bruk piltastane for å velje storleik på omrisset."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Skjermlesarar brukar dette for å skildre innhaldet i eit/ein { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Skjermlesarar brukar dette for å skildre innhaldet i eit bilde"
  },
  "used_by_screen_readers_to_describe_the_video_37ebad25": {
    "message": "Brukt av skjermlesarar for å skildre videoen"
  },
  "user_documents_c206e61f": {
    "message": "Brukardokument"
  },
  "user_files_78e21703": {
    "message": "Brukarfiler"
  },
  "user_images_b6490852": {
    "message": "Hent bilde frå mine filer"
  },
  "user_media_14fbf656": {
    "message": "Brukarmedia"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (Notasjon)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Vertikal strek (mengdebyggjarnotasjon)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Vertikale prikkar"
  },
  "video_options_24ef6e5d": {
    "message": "Videoalternativ"
  },
  "video_options_tray_3b9809a5": {
    "message": "Menyalternativ for video"
  },
  "video_player_b371005": {
    "message": "Videoavspelar"
  },
  "video_player_for_9e7d373b": {
    "message": "Videospelar for"
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Videospelar for { title }"
  },
  "view_all_e13bf0a6": {
    "message": "Vis alt"
  },
  "view_ba339f93": {
    "message": "Vis"
  },
  "view_description_30446afc": {
    "message": "Vis skildring"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Sjå hurtigtastar"
  },
  "view_title_description_67940918": {
    "message": "Vis { title } skildring"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Sjå ord- og karaktertelling"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Kunne ikkje finne ein fungerande mikrofon tilkopla maskina di."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Kunne ikkje finne eit fungerande kamera tilkopla maskina di."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Kunne ikkje finne eit fungerande kamera eller mikrofon tilkopla maskina di."
  },
  "webcam_disabled_30c66986": {
    "message": "Webkamera deaktivert"
  },
  "webcam_fe91b20f": {
    "message": "Webkamera"
  },
  "white_87fa64fd": {
    "message": "Kvit"
  },
  "why_523b3d8c": {
    "message": "Kvifor"
  },
  "width_492fec76": {
    "message": "Vidde"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Vidde og breidde må vere tal"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki-startside"
  },
  "word_count_c77fe3a6": {
    "message": "Ordtelling"
  },
  "words_b448b7d5": {
    "message": "Ord"
  },
  "wreath_product_200b38ef": {
    "message": "Kransprodukt"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ja"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Du har endringar som ikkje er lagra i ikondesignaren. Ønsker du å fortsette utan å lagre endringane?"
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Du kan ikkje laste opp ei tom fil."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Bildet ditt har blitt komprimert for ikondesignaren. Bilder mindre enn { size } KB blir ikkje komprimert."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofonen din er blokkert i nettlesarinnstillingane."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Webkamera og mikrofonen din er blokkert i nettleserinnstillingane."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Webkamera ditt er blokkert i nettleserinnstillingane."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Ditt webkamera kan allereie være i bruk"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zoom inn på bilde"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zoom ut frå bilde"
  }
};
formatMessage.addLocale({
  nn: locale
});